import { JobRoleCreateDto, JobRoleDetailsDto, JobRolesListElement, JobRoleUpdateDto } from 'types/jobRoles';
import { portalAPI } from './portalAPI';
import { accumulatedQueryWithFilters } from './util/endpointBuilder';

const APIJobRolesSlice = portalAPI.enhanceEndpoints({ addTagTypes: ['JobRoles'] }).injectEndpoints({
    endpoints: (builder) => ({
        getJobRoleById: builder.query<JobRoleDetailsDto, string>({
            query: (id) => `/v1/job-roles/${id}`,
            keepUnusedDataFor: 0,
        }),
        getJobRolesList: builder.query<JobRolesListElement[], void>({
            query: () => '/v1/job-roles',
            keepUnusedDataFor: 0,
            providesTags: ['JobRoles'],
        }),
        getJobRolesWithFilters: accumulatedQueryWithFilters<JobRolesListElement>(builder, '/v1/job-roles', {
            providesTags: ['JobRoles'],
        }),
        addJobRole: builder.mutation<JobRolesListElement, JobRoleCreateDto>({
            query: ({ ...body }) => ({
                url: `/v1/job-roles`,
                method: 'POST',
                body,
            }),
            invalidatesTags: ['JobRoles'],
        }),
        updateJobRole: builder.mutation<JobRolesListElement, JobRoleUpdateDto>({
            query: ({ id, ...body }) => ({
                url: `/v1/job-roles/${id}`,
                method: 'PUT',
                body,
            }),
            invalidatesTags: ['JobRoles'],
        }),
        deleteJobRole: builder.mutation<boolean, { id: string }>({
            query: ({ id }) => ({
                url: `/v1/job-roles/${id}`,
                method: 'DELETE',
            }),
            invalidatesTags: ['JobRoles'],
        }),
    }),
    overrideExisting: false,
});

export const {
    useGetJobRoleByIdQuery,
    useGetJobRolesListQuery,
    useLazyGetJobRolesWithFiltersQuery,
    useAddJobRoleMutation,
    useUpdateJobRoleMutation,
    useDeleteJobRoleMutation,
} = APIJobRolesSlice;
